export const FETCH_INSTANCE_BASE = 'FETCH_INSTANCE'
export const FETCH_INSTANCE_PENDING = 'FETCH_INSTANCE_PENDING'
export const FETCH_INSTANCE_REJECTED = 'FETCH_INSTANCE_REJECTED'
export const FETCH_INSTANCE_FULFILLED = 'FETCH_INSTANCE_FULFILLED'
export const SET_INSTANCE_PROPERTY = "SET_INSTANCE_PROPERTY";
